import { memo, PropsWithChildren } from 'react';

import { Props } from '@/ui/components/Tooltip/types';
import { Tooltip as NewTooltip } from '@/ui/Tooltip/Tooltip';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 * Note: the new component doesn't support customizing `offset`/`arrowHeight` — both are
 * unused by any current caller, so this drops without a behavior change.
 */
const Tooltip = ({
  children,
  tooltipContent,
  placement = 'top',
  disabled = false,
  interactive = false,
  arrow: arrowEnabled = true,
  className = ''
}: PropsWithChildren<Props>) => (
  <NewTooltip
    content={tooltipContent}
    placement={placement}
    disabled={disabled}
    interactive={interactive}
    showArrow={arrowEnabled}
    className={className}>
    {children}
  </NewTooltip>
);

export default memo(Tooltip);
